import { z } from 'zod';

// Settings fields with a Discord meaning (plan 1C Chunk 5). They're strings, empty or
// a Discord id, marked with `.meta({ itc: { discord } })`: `tx.announce` posts to a
// channel setting, and the admin panel's settings forms render pickers for both.

// A type alias, not an interface: zod's metadata wants an index signature.
export type DiscordFieldMeta = {
  itc: { discord: 'channel' | 'role'; channelTypes?: readonly ('text' | 'announcement' | 'forum' | 'voice' | 'category')[] };
};

const IdOrEmpty = z.string().regex(/^(|[0-9]{17,20})$/, 'a Discord id, or empty');

/** A Discord channel id, empty until an admin picks one. */
export function discordChannelSetting(options: { channelTypes?: DiscordFieldMeta['itc']['channelTypes']; description?: string } = {}) {
  const meta: DiscordFieldMeta = { itc: { discord: 'channel', ...(options.channelTypes ? { channelTypes: options.channelTypes } : {}) } };
  // One meta call: a later describe() would replace it.
  return IdOrEmpty.default('').meta({ ...meta, ...(options.description === undefined ? {} : { description: options.description }) });
}

/** A Discord role id, empty until an admin picks one. */
export function discordRoleSetting(options: { description?: string } = {}) {
  const meta: DiscordFieldMeta = { itc: { discord: 'role' } };
  return IdOrEmpty.default('').meta({ ...meta, ...(options.description === undefined ? {} : { description: options.description }) });
}

/** Whether a settings field was made by discordChannelSetting or discordRoleSetting, and which. */
export function discordFieldKind(field: unknown): 'channel' | 'role' | undefined {
  if (!(field instanceof z.ZodType)) return undefined;
  const meta = field.meta() as Partial<DiscordFieldMeta> | undefined;
  const kind = meta?.itc?.discord;
  return kind === 'channel' || kind === 'role' ? kind : undefined;
}
